import { FORM_FIELD_TYPE_CODE, INPUT_TYPES } from '../../constants/formElements';
import { IFormElementsState } from '../reducers/formElementsReducer';
import ACTIONS_TYPES from '../../constants/types';
import { IRegistrationFormStep } from '../reducers/formConfigReducer';

const mapFormElements = (steps: IRegistrationFormStep[]): IFormElementsState => {
  let fieldInputTypeDict: IFormElementsState = {};

  steps.forEach((step) => {
    step.sections.forEach((section) => {
      section.elements.forEach((element) => {
        const inputType: FORM_FIELD_TYPE_CODE | undefined = INPUT_TYPES[element.typeCode];
        if (inputType) {
          fieldInputTypeDict = { ...fieldInputTypeDict, [element.fieldCode]: inputType };
        }
      });
    });
  });

  return fieldInputTypeDict;
};

interface ISetFormElementsAction {
  type: typeof ACTIONS_TYPES.SET_FORM_ELEMENTS;
  payload: IFormElementsState;
}

const setFormElementsAction = (steps: IRegistrationFormStep[]): ISetFormElementsAction => {
  return { type: ACTIONS_TYPES.SET_FORM_ELEMENTS, payload: mapFormElements(steps) };
};

export default { setFormElementsAction };

export type FormElementsActionTypes = ISetFormElementsAction;
